import {getEnvironment} from "../utils/getEnvironment";
import axios from "axios";

const environment = getEnvironment();

export default class Subscription {
    key: string;
    name: string;
    description: string;
    price: number;
    duration: number;

    constructor(key: string, name: string, description: string, price: number, duration: number) {
        this.key = key;
        this.name = name;
        this.description = description;
        this.price = price;
        this.duration = duration;
    }

    public static readonly list = async (start?: number, count?: number) =>
        (await axios
            .get(environment.api_url + "/subscription/list", {
                params: { start, count },
            })
            .then((res) => (res.status === 200 ? res.data : []))
            .catch(console.error)) as Subscription[];

}